
import { defineComponent, inject, ref, reactive, onMounted, watch } from "vue";
import { getOrderTable, postOrderWriteOff } from "@/api/http";
import { column } from "@/assets/types/common";
import { validateInput } from "@/assets/js/formRules";
import { Request } from "@/api/request";

type screen = {
    search: string;
    time: Array<string> | null;
    service: Array<number> | null;
};
type screenKey = keyof screen;
type order = {
    ordersn: string;
    create_time: string;
    project: string;
    classifcation: string;
    goodsprice: string;
    user_id: string;
    phone: number | null;
    pay_status_text: string;
    nucleus_pin_code: string;
    nucleus_pin_code_status: number;
    id: number;
};
const columnList: Array<column> = [
    {
        prop: "user_id",
        label: "会员号",
        width: 180,
    },
    {
        prop: "phone",
        label: "会员手机号",
        width: 164,
    },
    {
        prop: "price",
        label: "充值金额（元）",
        width: 80,
    }
];
const orderStatusNav: Array<{ name: string; id: number | string }> = [
    {
        name: "待审核",
        id: 0,
    },
    {
        name: "待打款",
        id: 1,
    },
    {
        name: "已打款",
        id: 2,
    },
];
export default defineComponent({
    name: "rechargeLog",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["充值记录"]);
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<order>),
            total = ref(0),
            loading = ref(true),
            screen = ref({
                search: "",
                time: null,
                service: null,
            } as screen),
            orderStatus = ref(0),
            screenParameter: any =ref( {
                page: currentPage.value,
                pagesize: pageSize.value,
                admin_status: orderStatusNav[orderStatus.value].id,
                type: 1
            } as any),
            shortcuts = ref([
                {
                    text: "最近一周",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        return [start, end];
                    })(),
                },
                {
                    text: "最近一个月",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        return [start, end];
                    })(),
                },
                {
                    text: "最近三个月",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        return [start, end];
                    })(),
                },
            ]),
            project = ref([]),
            dialogFormVisible = ref(false),
            orderDetail = ref({} as order),
            dialogNavIndex = ref(0),
            _payment = (id:number) => {
                Request.axiosInstance({
                    url: 'adminapi/Withdrawal/payment',
                    data: {id}
                }).then((res:any) => {
                    res.status == 202 && getTableData()
                })
            },
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请输入核销码", value, callback);
                        },
                        trigger: "change",
                    },
                ],
            }),
            formRef = ref(null);

        let getTableData = () => {
                loading.value = true;
                Request.axiosInstance({
                    url: 'adminapi/Order/rechargeLog',
                    data: screenParameter.value
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    project.value = res?.content?.project || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            selectChange = (
                e: string | Array<Date> | Array<number>,
                key: screenKey
            ): void => {
                if (!e) {
                    if (key == "service") {
                        delete screenParameter["project_type_pid"];
                        delete screenParameter["project_id"];
                    } else if (key == "time") {
                        delete screenParameter["start_time"];
                        delete screenParameter["end_time"];
                    } else {
                        delete screenParameter[key];
                    }
                } else {
                    if (key == "service") {
                        screenParameter["project_type_pid"] = e[0];
                        screenParameter["project_id"] = e[1];
                    } else if (key == "time") {
                        screenParameter["start_time"] =
                            (e[0] as Date).getTime() / 1000;
                        screenParameter["end_time"] =
                            (e[1] as Date).getTime() / 1000;
                    } else {
                        screenParameter[key] = e;
                    }
                }
                getTableData();
            },
            columnChange = (item: order, index: number) => {
               dialogFormVisible.value = true;
               orderDetail.value = item;
                dialogNavIndex.value = index;
            },
            check = (): void => {
                (formRef.value as any).validate((valid: boolean) => {
                    console.log(valid);
                    if (valid) {
                        postOrderWriteOff({
                            order_id: orderDetail.value.id,
                            nucleus_pin_code:
                                orderDetail.value.nucleus_pin_code,
                        }).then((res) => {
                            if (res.status == 202) {
                                orderDetail.value.pay_status_text = "已完成";
                                orderDetail.value.nucleus_pin_code_status = 1;
                                getTableData();
                            }
                        });
                    }
                });
            };
        onMounted(() => {
            getTableData();
        });
        watch(orderStatus, (newValue, oldValue) => {
          screenParameter.status = orderStatusNav[newValue].id
            getTableData();
        });
        return {
            headClass,
            columnList,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            orderStatusNav,
            orderStatus,
            screen,
            shortcuts,
            project,
            dialogFormVisible,
            orderDetail,
            dialogNavIndex,
            rules,
            formRef,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            columnChange,
            check,
            screenParameter,
            _payment
        };
    },
    mounted () {
       
    },
    methods:{
        a () {
            // (this.print as any).click()
            //  (this as any).$print(this.print)
        }
    }
});
